import Layout from '@/views/layout';

const CustomerRouter = {
	path: '/customer',
	name: 'Customer',
	component: Layout,
	meta: {
		title: '客户',
		role: [0, 1, 2, 3, 4]
	},
	redirect: {
		name: 'CustomerList'
	},
	children: [{
			path: 'customerList',
			name: 'CustomerList',
			component: () => import('@/views/customerManage/customer'),
			meta: {
				title: '客户',
				roles: [0, 1, 2, 3, 4],
				noCache: true
			}
		},
		{
			path: 'ownerCustome',
			name: 'OwnerCustome',
			component: () => import('@/views/customerManage/customer'),
			meta: {
				title: '我可以查看的客户',
				roles: [0, 1, 2, 3, 4],
				noCache: true
			}
		},
		{
			path: 'customerDetails',
			name: 'CustomerDetails',
			component: () => import('@/views/customerManage/customer/details'),
			meta: {
				title: '客户信息',
				role: [0, 1, 2, 3, 4],
				noCache: true
			}
		},
		{
			path: 'search',
			name: 'CustomerSearch',
			component: () => import('@/views/customerManage/customer/search'),
			meta: {
				title: '客户查询',
				role: [0, 1, 2, 3, 4],
				noCache: true
			}
		},
		{
			path: 'create',
			name: 'CreateCustomer',
			component: () => import('@/views/customerManage/customer/create'),
			meta: {
				title: '创建客户',
				role: [0, 1, 2, 3, 4],
				noCache: true
			}
		},
		{
			path: 'pool',
			name: 'CustomerPool',
			component: () => import('@/views/customerManage/pool'),
			meta: {
				title: '公海',
				role: [0, 1, 2, 3, 4],
				noCache: true
			}
		},
		{
			path: 'learned',
			name: 'CustomerLearned',
			component: () => import('@/views/courseslearned/index'),
			meta: {
				title: '已学课程',
				role: [0, 1, 2, 3, 4],
				noCache: true
			}
		}
		
	]
};

export default CustomerRouter;
